import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const ReactPortal = ({ children, position, onClose }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown-menu")) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!mounted) return null;

  return createPortal(
    <div
      className="dropdown-menu absolute z-[999] bg-white shadow-lg rounded-md border border-gray-200 py-1"
      style={{
        top: position?.top,
        left: position?.left,
        minWidth: "160px",
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export default ReactPortal;
